const NotificationHelper = {
    _checkInsText: {
        1: "Parab\xe9ns pelo teu primeiro check-in! Agora faz o check-in em todos os pontos que passares e habilita-te a pr\xe9mios e ofertas!",
        2: "Dobradinha (2 check-ins). Est\xe1s no bom caminho!",
        3: "Hat-trick (3 check-ins). Est\xe1s no bom caminho!",
        5: "5 check-ins \uD83D\uDD90 Aos 30 check-ins j\xe1 podes ganhar pr\xe9mios!",
        10: "10 check-ins! Visita mais 25 pontos de investigadores para trocares o teu primeiro pr\xe9mio.",
        20: "20 check-ins! Visita mais 15 pontos de investigadores para trocares o teu primeiro pr\xe9mio.",
        30: "Podes trocar um bon\xe9 NEI Coimbra 2023 (30 check-ins) ou mais 20 check-ins e habilitas-te a outro pr\xe9mio!",
        40: "40 check-ins! Est\xe1s a 10 check-ins de poderes trocar um pr\xe9mio!",
        50: "Podes trocar uma t-shirt ou um kit de reciclagem (50 check-ins). Visita o nosso ponto de informa\xe7\xe3o ou continua, mais 20 check-ins e habilitas-te a ganhar outro pr\xe9mio!",
        60: "60 check-ins! Est\xe1s a 10 check-ins de poderes trocar um pr\xe9mio!",
        65: "65 check-ins! Est\xe1s a 5 check-ins de poderes trocar um pr\xe9mio!",
        70: "Podes trocar um pr\xe9mio (70 check-ins). Visita o nosso ponto de informa\xe7\xe3o e continua, mais 23 check-ins para te tornares um campe\xe3o da ci\xeancia!",
        80: "Est\xe1s quase a tornar-te um campe\xe3o da ci\xeancia! Faz check-in em mais 13 pontos!",
        93: "Parab\xe9ns, fizeste check-in em todos os pontos, a Rota da Ci\xeancia \xe9 tua! Mereces fazer parte da nossa equipa de investiga\xe7\xe3o!"
    }
};
NotificationHelper.init = function(checkInCount) {
    notie.setOptions({
        alertTime: 30
    });
};
NotificationHelper.handleCheckIn = function(checkInCount) {
    if (checkInCount in NotificationHelper._checkInsText) setTimeout(()=>{
        notie.alert({
            type: 4,
            text: "\uD83D\uDC4D " + NotificationHelper._checkInsText[checkInCount] + " \uD83C\uDF89",
            position: "bottom"
        });
    }, 500);
};
NotificationHelper.getCheckInText = (checkInCount)=>{
    let index = checkInCount;
    while(index > 0){
        if (NotificationHelper._checkInsText[index]) return NotificationHelper._checkInsText[index];
        index--;
    }
    return "";
};

//# sourceMappingURL=index.d9e6a551.js.map
